import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { State } from '../../typings/state';
import { TDispatchProps, TStateProps } from '../../typings/utils';
import { openConstructor } from '../AddCreativePage/actions';
import { CanvasAction } from '../common/actions';
import { Page } from '../common/typings';

import { loadPresets } from './actions';
import { Presets } from './Presets';
import { PresetsProps } from './typings';

type DispatchProps = TDispatchProps<PresetsProps>;
const mapDispatchToProps = (dispatch: Dispatch<CanvasAction>): DispatchProps => {
    return {
        loadPresets: () => dispatch(loadPresets()),
        selectPreset: (presetId: string, isAdaptive?: boolean) =>
            dispatch(openConstructor(Page.PRESETS, presetId, undefined, undefined, isAdaptive))
    };
};

type StateProps = TStateProps<PresetsProps>;
export const mapStateToProps = (state: State): StateProps => {
    return state.canvasEditor.canvas.presets;
};

export const PresetsContainer = connect<StateProps, DispatchProps>(
    mapStateToProps,
    mapDispatchToProps
)(Presets);
